import React, { useCallback } from 'react';
import {
  Image,
  Linking,
  Pressable,
  StyleSheet,
  Text,
  View,
} from 'react-native';

import { DraggableSheet } from './reusable/DraggableSheet';

const navigateIcon = require('assets/navigation.svg');
const callIcon = require('assets/call.svg');

const testID = 'HelpPopup';

export function HelpPopup({ navigateExit, close, open }) {
  const callAction = useCallback(async () => {
    // Checking if the link is supported for links with custom URL scheme.
    const supported = await Linking.canOpenURL(`tel:${process.env.SOS_NUMBER}`);
    if (supported) {
      // Opening the link with some app, if the URL scheme is "http" the web link should be opened
      // by some browser in the mobile
      await Linking.openURL(`tel:${process.env.SOS_NUMBER}`);
    } else {
      console.log('cannot open url');
    }
  }, []);

  return (
    <DraggableSheet dismiss={close} testID={testID} open={open} id="sos">
      <Text testID={`${testID}_title`} style={styles.title}>
        Help
      </Text>
      <View style={styles.container}>
        <Pressable
          onPress={() => {
            navigateExit();
            close();
          }}
          style={styles.listItem}
        >
          <View style={[styles.iconContainer, styles.navIcon]}>
            <Image source={navigateIcon} style={styles.listIcon} />
          </View>
          <Text style={styles.listText}>Take me to the exit</Text>
        </Pressable>
        <Pressable
          onPress={() => {
            callAction();
            close();
          }}
          style={styles.listItem}
        >
          <View style={[styles.iconContainer, styles.callIcon]}>
            <Image source={callIcon} style={styles.listIcon} />
          </View>
          <Text style={styles.listText}>Contact QWR</Text>
        </Pressable>
      </View>
    </DraggableSheet>
  );
}

const styles = StyleSheet.create({
  container: {
    borderBottomColor: '#e6e6e6',
    borderBottomWidth: 1,
  },
  title: {
    fontSize: 25,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  listItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderTopColor: '#e6e6e6',
    borderTopWidth: 1,
    paddingVertical: 10,
  },
  listText: {
    fontSize: 20,
  },
  iconContainer: {
    backgroundColor: 'red',
    marginRight: 10,
    borderRadius: 25,
    padding: 10,
  },
  listIcon: {
    width: 20,
    height: 20,
  },
  navIcon: {
    backgroundColor: '#1e1eff',
  },
  callIcon: {
    backgroundColor: '#dd3416',
  },
});
